import { createContext, useState } from 'react'

const DataContext = createContext({
    type: { value: '', MODEL_NAME: '', display: '', ID_PREFIX: '' },
    tableData: [],
    locales: [],
    setType: () => { },
    setTableData: () => { },
    setLocales: () => { }
})

export function DataContextProvider({ children }) {
    const [type, setType] = useState({
        value: '', MODEL_NAME: '', display: '', ID_PREFIX: ''
    })
    const [tableData, setTableData] = useState([])
    const [locales, setLocales] = useState([])

    const context = { type, setType, tableData, setTableData, locales, setLocales }

    return (
        <DataContext.Provider value={context}>
            {children}
        </DataContext.Provider>)
}

export default DataContext